import type React from 'react';

import completedIcon from './assets/icon_completed.svg';
import inProgressIcon from './assets/icon_in_progress.svg';
import nextIcon from './assets/icon_next.svg';

type LessonStatusIconProps = {
  status?: string;
  isNextReccomendedLesson: boolean;
};

export const LessonStatusIcon: React.FC<LessonStatusIconProps> = ({
  status,
  isNextReccomendedLesson,
}) => {
  if (isNextReccomendedLesson) return <img src={nextIcon} alt="Next lesson" />;

  switch (status) {
    case 'completed':
      return <img src={completedIcon} alt="Completed lesson" />;
    case 'started':
      return <img src={inProgressIcon} alt="In progress lesson" />;
    default:
      return null;
  }
};
